import { configureStore } from "@reduxjs/toolkit";
import gameSettingsReducer from "./gameSettingsSlice";
import allPlayersReducer from "./allPlayersSlice";

export const store = configureStore({
  reducer: {
    gameSettings: gameSettingsReducer,
    allPlayers: allPlayersReducer,
  },
});
